import { IShopInfo, IShopConfig } from '@/model/types/shop'
import { observable, action } from 'mobx'
import { $post } from '@/api'

export default class ShopStore {
    @observable
    public shopInfo: IShopInfo | null = null

    @observable
    public shopConfig: IShopConfig | null = null

    @observable
    public userInfo: any = {}

    @action
    public setShopConfig(shopConfig: IShopConfig) {
        this.shopConfig = shopConfig
    }

    @action
    public getShopConfig() {
        $post({
            url: '/shop/getshopconfig',
        }).then((res: IShopConfig) => {
            this.shopConfig = res
        })
    }

    @action
    public setShopInfo(shopInfo: IShopInfo) {
        this.shopInfo = shopInfo
    }

    get currentVersion() {
        const wscVersion = this.shopInfo?.wsc_version
            ? this.shopInfo?.wsc_version > 0
                ? this.shopInfo?.wsc_version - 1
                : this.shopInfo?.wsc_version
            : -1

        return Math.max(wscVersion, this.shopInfo?.shop_version || -1)
    }

    get cashierVersion() {
        return this.shopInfo?.shop_version || -1
    }

    get wscVersion() {
        return this.shopInfo?.wsc_version
            ? this.shopInfo?.wsc_version > 0
                ? this.shopInfo?.wsc_version - 1
                : this.shopInfo?.wsc_version
            : -1
    }

    get isChainShop() {
        return !!this.shopInfo && !!this.shopInfo.chain_shop
    }

    @action
    public setUserInfo(userInfo: any) {
        this.userInfo = userInfo
    }
}

export const shopStore = new ShopStore()
